import { render, staticRenderFns } from "./TopScreen.vue?vue&type=template&id=5273a382&"
import script from "./TopScreen.vue?vue&type=script&lang=js&"
export * from "./TopScreen.vue?vue&type=script&lang=js&"
import style0 from "./TopScreen.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports